import axios from 'axios'
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

const Price = axios.create({
  timeout: 5000,
  headers: {'Cloud-Agent': 'LX-Cloud-Client V1.0'},
})
Price.isLogined = function(){
  if(PveSrv.Ticket === ''){
    return false;
  }
  if(Math.trunc(Date.now()/1000) - PveSrv.LoginTS > 3600){
    return false;
  }
  return true;
}

Price.getPrice = function(){
  return {
    /** 256GB, 512GB */
    "LX5-HL101": [ 51315, 56315],
    "LX5-HS101": [ 48225, 53225],
    "LX5-HP101": [ 69172, 74172],
    "LX5-HL302": [ 65982, 70982],
    "LX5-HS302": [ 68758, 73758],
    "LX5-HP302": [ 110502, 115502],
    "LX5-HL303": [ 80615, 85615],
    "LX5-HS303": [ 74714, 79714],
    "LX5-HP303": [ 96724, 101724],
    "LX5-ML011": [12922, 16922],
    "LX5-ML021": [28922, 32922],
    "LX5-ML022": [44452, 48452],
    "LX5-ML023": [59946, 63946],
    "LX5-MP022": [91591, 95591],
  }
}

Price.login = function(username, passwd){
  var params = {
        username: username,
        password: passwd
      };
  //console.log(ReqParams);
  var rs = PveSrv.post('/api2/json/access/ticket', params);
  rs.then(res=>{
    if(res.data.data.ticket !== undefined){
      //console.log(res);
    } else {
      //console.log(res);
    }
  },err=>{
    //console.log(err);
  });
  return rs;
}

export default Price


